import { i18next } from '@yola/ws-sdk';
import downloadOptions from '../constants/download-options';

const getDownloadOptions = () => [
  {
    label: i18next.t('Download on computer'),
    value: downloadOptions.DOWNLOAD_ON_COMPUTER,
  },
  {
    label: i18next.t('Open in a new tab'),
    value: downloadOptions.OPEN_IN_NEW_TAB,
  },
];

export default getDownloadOptions;
